import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

interface SendOtpVariables {
	phone: string,
	text: string,
	digits: number
}

interface ConfirmOtpVariables {
	phone: string,
	otp: string,
}

export class OtpController {
	async sendOtp(request: SendOtpVariables): Promise<any> {
		return await server.post('/Otp/send', request, {
			baseURL: BACKEND_URL
		});
	}

	async confirmOtp(request: ConfirmOtpVariables): Promise<any> {
		return await server.post("/Otp/confirm", request, {
			baseURL: BACKEND_URL
		});
	}
}